"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FEATURE_PATHS = void 0;
var FEATURE_PATHS = {
  treatmentPlan: "/treatment_plans/new"
};
exports.FEATURE_PATHS = FEATURE_PATHS;